import { render } from "./MImage.vue?vue&type=template&id=0d0959aa"
import script from "./MImage.vue?vue&type=script&lang=js"
export * from "./MImage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__